export default "__VITE_ASSET__BbUFLIyw__"